module.exports = __webpack_public_path__ + "media/images/lb/168-16e7858f4b3158e53eeb01f7bc722a6f.svg";